import React from 'react';

function Close() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M24 2.417L21.583 0 12 9.583 2.417 0 0 2.417 9.583 12 0 21.583 2.417 24 12 14.417 21.583 24 24 21.583 14.417 12z" />
    </svg>
  );
  /* eslint-enable */
}

export default Close;



// WEBPACK FOOTER //
// ./src/common/icons/Close.js